import React from "react";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer">
      <div className="row">
        <div className="col-12 col-md-5 mb-3 mb-md-0">
          <div className="footer_logotxt">Copyright © {currentYear}</div>
        </div>
        {/* <div class="col-12 col-md-7">
  </div> */}
      </div>
    </footer>
  );
}

export default Footer;
